<script>
  import { createEventDispatcher } from "svelte";

  export let title;
  export let bgColor = "#fff";
  export let bgGradient = null;

  const dispatch = createEventDispatcher();

  const bgSelect = () => (bgGradient === null ? bgColor : bgGradient);
  // console.log(bgSelect());
  let isOpen = false;
</script>

<div class="col-container">
  <!-- <div class:active={isOpen}> -->
  <div style="display: flex; flex-direction :row ; align-items: center ;">
    <p
      class="accordion-title"
      style="background: {bgSelect()} ; background-image : {bgGradient}"
      on:click={() => {
        isOpen = !isOpen;
        dispatch("isOpen", {
          isOpen: isOpen,
        });
      }}
    >
      {title}
    </p>
    <!-- this span for show of arrow indicator in the end of the accordion title -->
    <span style=" background-color:{bgColor};" class="fold-state"
      >{isOpen ? "-" : "+"}</span
    >
  </div>
  {#if isOpen}
    <slot />
  {/if}
</div>

<style>
  /* w3 accordion style */

  /* Add a background color to the button if it is clicked on (add the .active class with JS), and when you move the mouse over it (hover) */
  .accordion-title:hover {
    background-color: rgb(209, 255, 207);
  }

  p.accordion-title {
    width: 100%;
    font-size: 36px;
    font-family: "Quicksand", sans-serif;
    font-weight: bold;
    padding: 8px 8px 8px 15px;
    margin: 0;
    margin-top: 12px;
    color: #fff;
    /* border-style: 2px solid rgb(252, 10, 10); */
    border-radius: 16px;
    text-shadow: 1px 3px 5px rgb(31, 31, 31);

    cursor: pointer;
  }
  span.fold-state {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    font-size: 32px;
    font-weight: bold;
    /* text-align: center; */
    margin-left: -45px;
    margin-top: 12px;
    padding: 4px;
    border-style: 2px solid #000;
    border-radius: 16px;
  }
</style>
